import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import UpdateAccountMutation from '../../../../../mutations/ticketing/admin/useUpdateAccountMutation';

export interface UpdateAccountInput {
	autoCloseDays?: number;
	inboundLocalPart?: string | null;
	slug?: string;
	ticketNumberNext?: number;
	responseSlaValue?: number;
	responseSlaUnit?: string;
	resolutionSlaValue?: number;
	resolutionSlaUnit?: string;
}

export function useUpdateAccount() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function update(input: UpdateAccountInput): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UpdateAccountMutation,
				input,
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {update, loading, error, setError};
}
